import * as React from 'react'

export const SvgBasketIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width={24} height={24} aria-hidden={true} {...props}>
    <path d="M15.002 3l4.842 6.999L21 10a1 1 0 010 2l-3.472 7.812A2 2 0 0115.7 21H8.3a2 2 0 01-1.828-1.188L3 12a1 1 0 010-2l1.117-.001L9 3l1.627 1.19L6.574 10h10.818L13.37 4.183 15.002 3zm3.808 9H5.19l3.11 7h7.396l3.114-7z" />
  </svg>
)
export default SvgBasketIcon
